import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { openRegisterDialog as openRegisterDialogAction, goToLogin as goToLoginAction } from '@Containers/Header/HeaderComponentActions';
import HamburgerMenu from './HamburgerMenu';

function HamburgerMenuContainerComponent(props) {
  const { openRegisterDialog, goToLogin } = props;

  const onRegisterClick = (...args) => {
    openRegisterDialog(...args);
  };

  const onSignInClick = (...args) => {
    goToLogin(...args);
  };

  return <HamburgerMenu {...props} onRegisterClick={onRegisterClick} onSignInClick={onSignInClick} />;
}

HamburgerMenuContainerComponent.propTypes = {
  openRegisterDialog: PropTypes.func,
  goToLogin: PropTypes.func,
};

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = {
  openRegisterDialog: openRegisterDialogAction,
  goToLogin: goToLoginAction,
};

const HamburgerMenuContainer = compose(connect(mapStateToProps, mapDispatchToProps))(HamburgerMenuContainerComponent);
export default HamburgerMenuContainer;
